import script from "./RefiDisbursementsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./RefiDisbursementsTab.vue?vue&type=script&setup=true&lang=ts"

import "./RefiDisbursementsTab.vue?vue&type=style&index=0&id=15ab06b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15ab06b0"]])

export default __exports__